// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
// import { CartLineModel } from "@insite/client-framework/Types/ApiModels"; // Starter Custom Code
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import React, { useState } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { CartLineModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { imageStyles } from "@store/Themes/common/mixins/image";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import useExpandProps from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import upperFirst from "lodash/upperFirst";

type ProductImageSize = "small" | "medium" | "large";
/* Starter Custom Code - End */

interface OwnProps {
    product: CartLineModel | ProductContextModel | ProductModel; // Starter Custom Code
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductImageStyles;
    showSmallImage?: boolean;
    // Starter Custom Code
    overridedStyles?: ProductImageStyles;
    size?: ProductImageSize;
    href?: string;
}

type Props = OwnProps;

export interface ProductImageStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
    // Starter Custom Code
    wrapper?: InjectableCss;
}

export const productImageStyles: ProductImageStyles = {
    linkWrappingImage: {
        css: css`
            ${focusStyles()}
            width: 100%;
        `,
    },
    wrapper: {
        css: css`
            width: 100%;

            > span {
                cursor: default;
            }
        `,
    },
};

const ProductImage = ({
    product: baseProduct, // Starter Custom Code
    onClick,
    extendedStyles,
    showSmallImage,
    // Starter Custom Code
    overridedStyles,
    size = "small",
    href,
}: Props) => {
    /* Starter Custom Code - Start */
    const styles = useExpandProps(productImageStyles, extendedStyles, overridedStyles);
    const product = "product" in baseProduct ? baseProduct.product : baseProduct;
    const trackSelectItem = ga.use.trackSelectItem({ items: product });
    const { extensionCatalogSettings } = useSettingsCollection();

    let altText =
        ("imageAltText" in product && product.imageAltText) || ("altText" in product && product.altText) || "";
    if (!altText || altText === "") {
        altText =
            ("productTitle" in product && product.productTitle) ||
            ("productName" in product && product.productName) ||
            "";
    }

    const notFoundImagePath = (extensionCatalogSettings as any)?.[`notFound${upperFirst(size)}ImagePath`];
    const pathProperty = `${size}ImagePath`;
    const imagePath = (product as any).product?.[pathProperty] || (product as any)?.[pathProperty] || notFoundImagePath;

    const productDetailPath =
        "productInfo" in baseProduct
            ? baseProduct.productInfo.productDetailPath
            : ("productUri" in product && product.productUri) || "";

    const isActive = "isActive" in product ? product.isActive : true;

    const productIdx = "idx" in product && product.idx;
    const loading = typeof productIdx === "number" && productIdx < 3 ? "eager" : "lazy";

    const clickableCss = css`
        ${x => imageStyles(x.theme.design.product.image[size].ratio)}
        ${styles.linkWrappingImage?.css}
    `;

    const clickableHref = href || (isActive && productDetailPath ? productDetailPath : undefined);

    return (
        <StyledWrapper {...styles.wrapper} onClick={() => trackSelectItem()}>
            <Clickable
                {...styles.linkWrappingImage}
                href={clickableHref}
                onClick={onClick}
                data-test-selector="productImage"
                css={clickableCss}
            >
                {/* Starter Removed - next line - width, height */}
                <Img {...styles.img} loading={loading} src={imagePath} altText={altText} />
            </Clickable>
        </StyledWrapper>
    );
    /* Starter Custom Code - End */
};

export default ProductImage;
